module.exports = __webpack_public_path__ + "img/huilan.30082249.png";